<template>
  <div class="container lnb d_container">
    <div class="contents_wrap">
      <div class="contents list-container">
        <div class="title">
          공지사항등록
        </div>
        <board-write-component :boardType="'noticeCreate'"></board-write-component>
        <div class="pa15 text-center btn_wrap">
          <el-button class="reg_btn_out" @click="save">저장</el-button>
          <el-button class="com_btn" @click="backEvent()" :disabled="disableBtn">목록</el-button>

        </div>
      </div>
      <div class="text_center">Copyright 2020.</div>
    </div>
  </div>
</template>

<script>
import EventBus from "@/utils/event-bus";
import BoardWriteComponent from "@/components/board/BoardWriteComponent";

export default {
  name: "NoticeCreate",
  mixins: [],
  components: {BoardWriteComponent},
  provide() {
    return {}
  },
  props: {},
  data() {
    return {
      disableBtn: false,
    }
  },
  created() {
  },
  mounted() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {
    save() {
      EventBus.$emit('runNoticeWriteConfirm')
    },
    backEvent() {
      this.disableBtn = true
      this.$router.back()
    },
  },
  watch: {},
}
</script>

<style lang="scss">
</style>